import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <span className="font-display inline-flex items-center gap-2 rounded-full border border-purple-500/30 bg-[#0E0E16]/80 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-purple-300">
    <span className="h-1.5 w-1.5 rounded-full bg-[#14F195] animate-pulse-dot" />
    {children}
  </span>
);
